import { CheckCreator } from 'lib/utils/formValidation/formValidation';
import isEmpty from 'lib/utils/formValidation/isEmpty';

/*
  We don't want to surface validation errors until all values to be matched are entered.
  Therefore, we short-circuit the validation if any of the values of interest are missing.
*/
/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
const isLength: CheckCreator = (length: number) => (value: string) =>
  isEmpty(value) || value.length === length;

export default isLength;
